module.exports = __webpack_public_path__ + "e888a0baa5ec6719c6530a86ccc98cf1.svg";